import { inject, Pipe, PipeTransform } from '@angular/core';
import { UnitSystemType } from '@data-access';
import { UnitCategory, UnitDisplay } from '../utils/unit-conversion.utils';
import { UnitSystemService } from '../services/unit-system.service';

/**
 * Returns translation key. Use with 'translate' pipe
 */

@Pipe({ name: 'unitLabel', standalone: true })
export class UnitLabelPipe implements PipeTransform {
  private service = inject(UnitSystemService);

  transform(
    category: UnitCategory,
    unitSystem?: UnitSystemType | null,
    display: UnitDisplay = 'short',
  ): string {
    return this.service.resolveLabelKey(category, unitSystem, display);
  }
}
